export default (component) => {
  if (!component.mixins) {
    component.mixins = []
  }

  component.props.label = {
    type: String,
    default: 'Select'
  }

  component.mixins.push({
    inject: {
      modal: {
        default: null
      }
    },
    watch: {
      '$modal.focused': {
        handler(modal) {
          if (modal && this.visible) {
            this.visible = false
          }
        }
      }
    },
    mounted() {
      const popper = this.$refs.popper

      if (this.modal && popper && !popper._modalPatch) {
        popper._modalPatch = true
        const update = popper.updatePopper

        popper.updatePopper = () => {
          update.call(popper)

          const zIndex = popper.$el.style.zIndex
          const mIndex = this.modal.zIndex

          if (zIndex < mIndex) {
            const diff = mIndex - zIndex
            popper.$el.style.zIndex = zIndex + diff
          }
        }
      }
    }
  })

  component.mixins.push({
    mounted() {
      this.updateLabel()
    },
    updated() {
      this.updateLabel()
    },
    methods: {
      updateLabel() {
        this.$nextTick(() => {
          const input = Object(Object(this.$refs.reference).$refs).input

          if (input) {
            input.setAttribute('aria-label', this.label)
          }
        })
      }
    }
  })
}
